module.exports = __webpack_public_path__ + "img/Pellets-zertifikat.4094e53.webp";